import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const RemoveHistoryModal = ({ showRemoveHistoryModal, closeModal, removeTradeHistory, trade }) => {
  return (
    <Modal show={showRemoveHistoryModal} onHide={closeModal} className="trade-history-modal">
      <Modal.Header closeButton>
        <Modal.Title>Remove From Trade History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>This action will remove the following from trade history:</p>
        <h5>{`${trade.symbol} ${trade.tradeType} ${trade.tradeDate}`}</h5>
        <Button
          onClick={() => {
            removeTradeHistory({ tradeHistoryId: trade.id});
            closeModal();
          }}
          className="btn-red add"
          bsStyle="danger"
        >Remove From Trade History</Button>
      </Modal.Body>
      <Modal.Footer>
        <Button
          bsStyle="default"
          onClick={closeModal}
        >Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default RemoveHistoryModal;